'use strict';

var _utils = require('./src/_utils.js');
var Fade = require('./src/Fade.js');
var ScaleFade = require('./src/ScaleFade.js');
var SlideFade = require('./src/SlideFade.js');
var Collapse = require('./src/Collapse.js');



exports.EASINGS = _utils.EASINGS;
exports.Fade = Fade.Fade;
exports.ScaleFade = ScaleFade.ScaleFade;
exports.SlideFade = SlideFade.SlideFade;
exports.Collapse = Collapse.Collapse;
//# sourceMappingURL=index.js.map
